// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1sDS0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2XPCW","obliqueLine":"membershipbadge_obliqueLine__3WJph"};